export default {
    JSErrorRate: {
        value: '2556',
        name: 'js错误率',
        des: '周同比:',
        rate: '10.1',
        isRise: true,
    },
    APISuccessRate: {
        value: '3456',
        name: 'API成功率',
        des: '周同比:',
        rate: '10.1',
        isRise: true,
    },
    FirstRenderTime: {
        value: '3456ms',
        name: '首次渲染时间',
        des: '周同比:',
        rate: '10.1',
        isRise: true,
    },
    ResourceError: {
        value: '3456',
        name: '资源错误',
        des: '周同比:',
        rate: '10.1',
        isRise: false,
    },
};
